<mat-card-title mat-dialog-title class="d-flex align-items-center mb-0">
  <mat-icon class="mr-2">message</mat-icon>
  {{ 'messages.create-thread' | translate }}
</mat-card-title>
<mat-card-subtitle class="popup-subtitle mb-1">{{
  'messages.subtitle' | translate
}}</mat-card-subtitle>

<mat-divider></mat-divider>

<mat-dialog-content>
  <form [formGroup]="createThreadForm">
    <div class="row pt-3 pb-2">
      <div class="col-12">{{ 'messages.receiving-party' | translate }} *</div>
    </div>
    <!-- Receiving Party -->

    <div class="row">
      <div class="col-md-4 col-sm-12" style="padding-right: 7.5px">
        <button
          mat-flat-button
          [color]="this.ruleType === TO_RULE_TYPE.TO_IDENTITY ? 'primary' : ''"
          (click)="onTypeSelected(TO_RULE_TYPE.TO_IDENTITY)"
          class="d-flex justify-content-between selction-btn"
          value="{{ TO_RULE_TYPE.TO_IDENTITY }}"
          type="button"
        >
          <!-- <div class="d-flex justify-content-between"> -->
          <div>
            {{ 'setup.messages.add-new-rule.to-identity' | translate }}
          </div>
          <mat-icon class="mt-1">person</mat-icon>
          <!-- </div> -->
        </button>
      </div>
      <div
        class="col-md-4 col-sm-12"
        style="padding-left: 7.5px; padding-right: 7.5px"
      >
        <button
          mat-flat-button
          [color]="this.ruleType === TO_RULE_TYPE.TO_ROLE ? 'primary' : ''"
          (click)="onTypeSelected(TO_RULE_TYPE.TO_ROLE)"
          class="d-flex justify-content-between selction-btn"
          value="{{ TO_RULE_TYPE.TO_ROLE }}"
          type="button"
        >
          <!-- <div class="d-flex justify-content-between"> -->
          <div>{{ 'setup.messages.add-new-rule.to-role' | translate }}</div>
          <mat-icon class="mt-1">account_circle</mat-icon>
          <!-- </div> -->
        </button>
      </div>
      <div
        class="col-md-4 col-sm-12"
        style="padding-left: 7.5px; padding-right: 15px"
      >
        <button
          mat-flat-button
          [color]="this.ruleType === TO_RULE_TYPE.TO_GROUP ? 'primary' : ''"
          (click)="onTypeSelected(TO_RULE_TYPE.TO_GROUP)"
          class="d-flex justify-content-between selction-btn"
          value="{{ TO_RULE_TYPE.TO_GROUP }}"
          type="button"
        >
          <!-- <div class="d-flex justify-content-between"> -->
          <div>{{ 'setup.messages.add-new-rule.to-group' | translate }}</div>
          <mat-icon class="mt-1">group</mat-icon>
          <!-- </div> -->
        </button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <!-- Send To -->
        <el-async-autocomplete
          *ngIf="ruleType === TO_RULE_TYPE.TO_IDENTITY"
          label="{{ 'messages.send-to' | translate }}"
          [filteredOptionsFromParent]="usersListForAsyncAutoComplete"
          [selectionModes]="SELECTION_MODE.CHIPS"
          [size]="10"
          [total]="totalUsers"
          [isRequired]="true"
          [selectedForEdit]="selectedIdentityReceiver ?? undefined"
          (selectedItems)="selectIdentity($event)"
          (asyncInput)="onFilterMembers($event)"
          [hasAvatar]="true"
          [markAsTouched]="isReceiverMarkAsTouched"
          [showError]="isShowIdentityError"
        >
        </el-async-autocomplete>
        <el-async-autocomplete
          *ngIf="ruleType === TO_RULE_TYPE.TO_ROLE"
          label="{{ 'messages.send-to' | translate }}"
          [filteredOptionsFromParent]="usersListForAsyncAutoComplete"
          [selectionModes]="SELECTION_MODE.CHIPS"
          [size]="10"
          [total]="totalUsers"
          [isRequired]="true"
          [selectedForEdit]="selectedRoleReceiver ?? undefined"
          (selectedItems)="selectRole($event)"
          (asyncInput)="onFilterMembers($event)"
          [markAsTouched]="isReceiverMarkAsTouched"
          [showError]="isShowRoleError"
        >
        </el-async-autocomplete>
        <el-async-autocomplete
          *ngIf="ruleType === TO_RULE_TYPE.TO_GROUP"
          label="{{ 'messages.send-to' | translate }}"
          [filteredOptionsFromParent]="usersListForAsyncAutoComplete"
          [selectionModes]="SELECTION_MODE.CHIPS"
          [size]="10"
          [total]="totalUsers"
          [isRequired]="true"
          [selectedForEdit]="selectedGroupReceiver ?? undefined"
          (selectedItems)="selectGroup($event)"
          (asyncInput)="onFilterMembers($event)"
          [markAsTouched]="isReceiverMarkAsTouched"
          [showError]="isShowGroupError"
        >
        </el-async-autocomplete>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="fill"
          class="main-form-field w-100"
          hintLabel="{{ 'messages.subject-char-limit' | translate }}"
        >
          <mat-label>{{ 'messages.subject' | translate }}</mat-label>
          <input
            data-testid="messages_create_thread_input_message_subject"
            type="text"
            matInput
            #subjectField
            maxlength="70"
            formControlName="subject"
            required
            placeholder="{{ 'messages.subject-placeholder' | translate }}"
          />
          <mat-hint align="end"
            >{{ subjectField.value?.length || 0 }}/70</mat-hint
          >
          <mat-error
            *ngIf="
              createThreadForm.get('subject').hasError('required') ||
              createThreadForm.get('subject').hasError('whitespace')
            "
          >
            {{ 'messages.error-hint' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Priority -->

    <div class="row pt-2 mt-2 pb-2">
      <div class="col-12">{{ 'messages.priority' | translate }} *</div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-12" style="padding-right: 7.5px">
        <button
          mat-flat-button
          [color]="this.priorityType === MESSAGE_PRIORITY.LOW ? 'primary' : ''"
          (click)="onPrioritySelected(MESSAGE_PRIORITY.LOW)"
          class="d-flex justify-content-between selction-btn"
          value="{{ MESSAGE_PRIORITY.LOW }}"
          type="button"
        >
          <!-- <div class="d-flex justify-content-between"> -->
          <div>
            {{ 'messages.button.low' | translate }}
          </div>
          <mat-icon class="mt-1">email</mat-icon>
          <!-- </div> -->
        </button>
      </div>
      <div
        class="col-md-4 col-sm-12"
        style="padding-left: 7.5px; padding-right: 7.5px"
      >
        <button
          mat-flat-button
          [color]="
            this.priorityType === MESSAGE_PRIORITY.MEDIUM ? 'primary' : ''
          "
          (click)="onPrioritySelected(MESSAGE_PRIORITY.MEDIUM)"
          class="d-flex justify-content-between selction-btn"
          value="{{ MESSAGE_PRIORITY.MEDIUM }}"
          type="button"
        >
          <!-- <div class="d-flex justify-content-between"> -->
          <div>{{ 'messages.button.medium' | translate }}</div>
          <mat-icon class="mt-1">mark_email_unread</mat-icon>
          <!-- </div> -->
        </button>
      </div>
      <div
        class="col-md-4 col-sm-12"
        style="padding-left: 7.5px; padding-right: 15px"
      >
        <button
          mat-flat-button
          [color]="this.priorityType === MESSAGE_PRIORITY.HIGH ? 'primary' : ''"
          (click)="onPrioritySelected(MESSAGE_PRIORITY.HIGH)"
          class="d-flex justify-content-between selction-btn"
          value="{{ MESSAGE_PRIORITY.HIGH }}"
          type="button"
        >
          <!-- <div class="d-flex justify-content-between"> -->
          <div>{{ 'messages.button.high' | translate }}</div>
          <mat-icon class="mt-1">warning</mat-icon>
          <!-- </div> -->
        </button>
      </div>
    </div>

    <!-- Rich Text Editor -->
    <div class="row pt-2 mt-2 pb-2">
      <div class="col-12">Message *</div>
    </div>

    <div class="mt-1 mb-3">
      <ckeditor
        ngDefaultControl
        data-testid="messages_create_thread_input_message"
        #ckeEditor
        [editor]="editor"
        [config]="editorConfig"
        formControlName="message"
        style="width: 100%"
        (change)="editorChange()"
        [required]="true"
      >
      </ckeditor>
      <mat-error
        *ngIf="
          createThreadForm.get('message').touched &&
          createThreadForm.get('message').hasError('required')
        "
        class="message-error ml-2 mt-1"
        >Message is required
      </mat-error>
    </div>

    <div class="row pt-2 mt-2 pb-2">
      <div class="col-12">Attachments</div>
    </div>

    <div class="mt-1 mb-3">
      <app-drag-and-drop
        data-testid="messages_create_thread_upload_file"
        style="width: 100%"
        [allowUpload]="true"
        [allowDelete]="false"
        [displayImg]="true"
        [uploadDirectly]="false"
        (triggerFileSelected)="triggerFileSelected($event)"
        [imgURLList]=""
        [showUploadedFiles]="false"
        [title]="title"
        [allowedTypesNames]="allowedTypesNames"
        [allowedTypesRegex]="allowedTypesRegex"
        [maxSize]="maxSize"
        [remainingFilesCount]="100"
        [remainingFiles]="false"
        required
      >
      </app-drag-and-drop>

      <app-display-data-in-dlt
        *ngIf="documentsDataList && documentsDataList.length !== 0"
        [dataListArray]="documentsDataList"
        (onClickAction)="action($event)"
      >
      </app-display-data-in-dlt>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 16px 24px">
  <button
    data-testid="messages_create_thread_btn_cancel"
    mat-button
    [mat-dialog-close]="false"
    [disabled]="isLoading"
  >
    {{ 'messages.button.cancel' | translate }}
  </button>
  <button
    data-testid="messages_create_thread_btn_send_message"
    mat-raised-button
    (click)="send()"
    cdkFocusInitial
    color="primary"
  >
    {{ 'messages.button.send' | translate }}
  </button>
  <mat-spinner
    *ngIf="isLoading"
    style="vertical-align: text-bottom; margin-left: 10px; margin-top: 5px"
    [diameter]="30"
  >
  </mat-spinner>
</mat-dialog-actions>
